import styled from "@emotion/styled";
import { useFormContext } from "react-hook-form";
import BasicButton from "@components/button/BasicButton";
import {
  FormTitle,
  Password,
} from "@pages/join/_components/index";
import { Nickname } from "./Nickname";
import { Birthday } from "./Birthday";
import { Gender } from "./Gender";
import { Address } from "./Address";
import { Country } from "./Country";
import { Name } from "./Name";
import LabelWithInput from "@components/input/LabelWithInput";

interface SignupFormProps {
  onSubmit?: () => void;
}

export default function SignupForm({ onSubmit }: SignupFormProps) {
  const {
    watch,
    formState: { isValid },
  } = useFormContext();

  const isFormValid = isValid && watch("isNicknameUnique") === true;
  const signupEmail = sessionStorage.getItem("signup_email") || "";

  return (
    <>
      <FormTitle>{"기본정보를 작성해주세요."}</FormTitle>
      <Container onSubmit={onSubmit} noValidate>
        {/* 이메일 (읽기전용) */}
        <LabelWithInput label={"이메일"} required={true}>
          <ReadOnlyEmail>{signupEmail}</ReadOnlyEmail>
        </LabelWithInput>

        {/* 비밀번호 입력 */}
        <Password />

        {/* 이름 입력 필드 */}
        <Name />
        {/* 닉네임 입력 필드 */}
        <Nickname />
        {/* 생년월일 선택 필드 */}
        <Birthday />
        {/* 성별 선택 필드 */}
        <Gender />
        {/* 국가 선택 필드 */}
        <Country />
        {/* 주소 선택 필드  */}
        <Address />
        <BasicButton
          title="회원가입"
          height="5.2rem"
          width="100%"
          padding="1.6rem 1.2rem"
          type="submit"
          disabled={!isFormValid}
        />
      </Container>
    </>
  );
}

const Container = styled.form({
  display: "flex",
  flexDirection: "column",
  gap: "4rem",
  paddingBottom: "2rem",
});

const ReadOnlyEmail = styled.div(({ theme }) => ({
  height: "5.2rem",
  display: "flex",
  alignItems: "center",
  padding: "0 1.6rem",
  backgroundColor: "#f5f5f5",
  border: "1px solid #e0e0e0",
  fontSize: "1.4rem",
  color: "#757575",
  marginTop: "1rem",
}));
